import _css from '../scss/styles.scss';
import './foundation/foundation-explicit-pieces';
import 'owl.carousel2';
import Slider from './ins/slider'; 
import simpleParallax from 'simple-parallax-js';
import EqualizeByRow from './ins/equalizeByRow';
import './ins/homepage'
import './ins/products'
import './ins/login'
import './ins/header'
import './ins/simulator'
import './ins/theme'


$(document).ready(()=>{
  $(document).foundation();
  
});